import { getAttendanceRecords as getAttendanceRecordsService } from "services/company/attendanceManagement/attendanceRecords/attendanceRecordsService";

import {
  getAttendanceRecordsStart,
  getAttendanceRecordsSuccess,
  getAttendanceRecordsFailure,
} from "./attendanceRecordsSlice";

import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch attendance records
export const fetchAttendanceRecords =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(getAttendanceRecordsStart());

      const response = await getAttendanceRecordsService(params);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(
          getAttendanceRecordsSuccess({
            data: response.data,
            pagination: response.pagination,
          }),
        );

        return {
          success: true,
          data: response.data,
          pagination: response.pagination,
        };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to fetch attendance records";

        dispatch(getAttendanceRecordsFailure(errorMsg));
        showErrorToast(errorMsg);

        return {
          success: false,
          error: errorMsg,
        };
      }
    } catch (error) {
      console.error("Fetch attendance records error:", error);

      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to fetch attendance records";

      dispatch(getAttendanceRecordsFailure(errorMsg));
      showErrorToast(errorMsg);

      return {
        success: false,
        error: errorMsg,
      };
    }
  };
